<template>
  <div>
    <b-card bg-variant="light">
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="memberIdInvalidFeedback" :valid-feedback="memberIdValidFeedback" :label="$t('sellerRegistration.memberId')" label-for="memberId">
        <b-form-input size="sm" id="memberId" v-model="memberId" type="text" :state="memberIdState" aria-describedby="memberIdFeedBack" :placeholder="$t('sellerRegistration.message.memberId')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="amazonAccountInvalidFeedback" :valid-feedback="amazonAccountValidFeedback" :label="$t('sellerRegistration.amazonAccount')" label-for="amazonAccount">
        <b-form-input size="sm" id="amazonAccount" v-model="amazonAccount" type="text" :state="amazonAccountState" aria-describedby="amazonAccountFeedBack" :placeholder="$t('sellerRegistration.message.amazonAccount')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="amazonShopNameInvalidFeedback" :valid-feedback="amazonShopNameValidFeedback" :label="$t('sellerRegistration.amazonShopName')" label-for="amazonShopName">
        <b-form-input size="sm" id="amazonShopName" v-model="amazonShopName" type="text" :state="amazonShopNameState" aria-describedby="amazonShopNameFeedBack" :placeholder="$t('sellerRegistration.message.amazonShopName')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="sellerIdInvalidFeedback" :valid-feedback="sellerIdValidFeedback" :label="$t('sellerRegistration.sellerId')" label-for="sellerId">
        <b-form-input size="sm" id="sellerId" v-model="sellerId" type="text" :state="sellerIdState" aria-describedby="sellerIdFeedBack" :placeholder="$t('sellerRegistration.message.sellerId')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="lastNameJpInvalidFeedback" :valid-feedback="lastNameJpValidFeedback" :label="$t('sellerRegistration.lastNameJp')" label-for="lastNameJp">
        <b-form-input size="sm" id="lastNameJp" v-model="lastNameJp" type="text" :state="lastNameJpState" aria-describedby="lastNameJpFeedBack" :placeholder="$t('sellerRegistration.message.lastNameJp')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="firstNameJpInvalidFeedback" :valid-feedback="firstNameJpValidFeedback" :label="$t('sellerRegistration.firstNameJp')" label-for="firstNameJp">
        <b-form-input size="sm" id="firstNameJp" v-model="firstNameJp" type="text" :state="firstNameJpState" aria-describedby="firstNameJpFeedBack" :placeholder="$t('sellerRegistration.message.firstNameJp')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="mwsTokenInvalidFeedback" :valid-feedback="mwsTokenValidFeedback" :label="$t('sellerRegistration.mwsToken')" label-for="mwsToken">
        <b-form-input size="sm" id="mwsToken" v-model="mwsToken" type="text" :state="mwsTokenState" aria-describedby="mwsTokenFeedBack" :placeholder="$t('sellerRegistration.message.mwsToken')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :label="$t('sellerRegistration.insuranceType')" label-for="insuranceType">
        <b-form-select size="sm" id="insuranceType" v-model="insuranceType" :options="insuranceTypes"/>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="spreadSheetUrlNormalInvalidFeedback" :valid-feedback="spreadSheetUrlNormalValidFeedback" :label="$t('sellerRegistration.spreadSheetUrlNormal')" label-for="spreadSheetUrlNormal">
        <b-form-input size="sm" id="spreadSheetUrlNormal" v-model="spreadSheetUrlNormal" type="text" :state="spreadSheetUrlNormalState" aria-describedby="spreadSheetUrlNormalFeedBack" :placeholder="$t('sellerRegistration.message.spreadSheetUrlNormal')"></b-form-input>
      </b-form-group>
      <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" :invalid-feedback="spreadSheetUrlSetInvalidFeedback" :valid-feedback="spreadSheetUrlSetValidFeedback" :label="$t('sellerRegistration.spreadSheetUrlSet')" label-for="spreadSheetUrlSet">
        <b-form-input size="sm" id="spreadSheetUrlSet" v-model="spreadSheetUrlSet" type="text" :state="spreadSheetUrlSetState" aria-describedby="spreadSheetUrlSetFeedBack" :placeholder="$t('sellerRegistration.message.spreadSheetUrlSet')"></b-form-input>
      </b-form-group>
      <b-btn size="sm" class="float-right" @click="registerSeller" :disabled="!memberIdState || !amazonAccountState || !amazonShopNameState || !sellerIdState || !lastNameJpState || !firstNameJpState || !mwsTokenState || !spreadSheetUrlNormalState || !spreadSheetUrlSetState" variant="danger">{{$t('sellerRegistration.register')}}</b-btn>
      <b-modal ref="registerSellerResult" ok-only hide-header>
        <div class="text-center">{{confirmMessage}}</div>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import InsuranceType from '@/types/InsuranceType'
import * as api from '@/api';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      memberId: '',
      amazonAccount: '',
      amazonShopName: '',
      sellerId: '',
      lastNameJp: '',
      firstNameJp: '',
      mwsToken: '',
      spreadSheetUrlNormal: '',
      spreadSheetUrlSet: '',
      insuranceType: '0',
      spreadSheetUrl: '',
      confirmMessage: '',
      insuranceTypes: InsuranceType.values(),
    };
  },
  computed: {
    memberIdState() {
      return (this.memberId.length  > 0) ? true : false;
    },
    memberIdInvalidFeedback() {
      return this.memberIdState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    memberIdValidFeedback() {
      return this.memberIdState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    amazonAccountState() {
      return (this.amazonAccount.length  > 0) ? true : false;
    },
    amazonAccountInvalidFeedback() {
      return this.amazonAccountState === false ? this.$i18n.t('sellerRegistration.message.requireParameterAndDetails') : '';
    },
    amazonAccountValidFeedback() {
      return this.amazonAccountState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    amazonShopNameState() {
      return (this.amazonShopName.length  > 0) ? true : false;
    },
    amazonShopNameInvalidFeedback() {
      return this.amazonShopNameState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    amazonShopNameValidFeedback() {
      return this.amazonShopNameState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    sellerIdState() {
      return (this.sellerId.length  > 0) ? true : false;
    },
    sellerIdInvalidFeedback() {
      return this.sellerIdState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    sellerIdValidFeedback() {
      return this.sellerIdState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    lastNameJpState() {
      return (this.lastNameJp.length  > 0) ? true : false;
    },
    lastNameJpInvalidFeedback() {
      return this.lastNameJpState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    lastNameJpValidFeedback() {
      return this.lastNameJpState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    firstNameJpState() {
      return (this.firstNameJp.length  > 0) ? true : false;
    },
    firstNameJpInvalidFeedback() {
      return this.firstNameJpState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    firstNameJpValidFeedback() {
      return this.firstNameJpState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    mwsTokenState() {
      return (this.mwsToken.length  > 0) ? true : false;
    },
    mwsTokenInvalidFeedback() {
      return this.mwsTokenState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    mwsTokenValidFeedback() {
      return this.mwsTokenState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    spreadSheetUrlNormalState() {
      return (this.spreadSheetUrlNormal.length  > 0) ? true : false;
    },
    spreadSheetUrlNormalInvalidFeedback() {
      return this.spreadSheetUrlNormalState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    spreadSheetUrlNormalValidFeedback() {
      return this.spreadSheetUrlNormalState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
    spreadSheetUrlSetState() {
      return (this.spreadSheetUrlSet.length  > 0) ? true : false;
    },
    spreadSheetUrlSetInvalidFeedback() {
      return this.spreadSheetUrlSetState === false ? this.$i18n.t('sellerRegistration.message.requireParameter') : '';
    },
    spreadSheetUrlSetValidFeedback() {
      return this.spreadSheetUrlSetState === true ? this.$i18n.t('sellerRegistration.message.ok') : '';
    },
  },
  methods: {
    registerSeller() {
      api.registerSeller(this.memberId, this.amazonAccount, this.amazonShopName, this.sellerId,
        this.lastNameJp, this.firstNameJp, this.mwsToken, this.insuranceType, this.spreadSheetUrlNormal, this.spreadSheetUrlSet,(items, password)=>{
          this.confirmMessage = '登録しました。初期化後のパスワードは「' + password + '」です。';
          this.$refs.registerSellerResult.show();
          this.memberId = '';
          this.amazonAccount = '';
          this.amazonShopName = '';
          this.sellerId = '';
          this.lastNameJp = '';
          this.firstNameJp = '';
          this.mwsToken = '';
          this.insuranceType = '0';
          this.spreadSheetUrlNormal = '';
          this.spreadSheetUrlSet = '';
        });
    },
  },
};
</script>

<style>
.col-form-label {
  font-size: small;
}
</style>
